import { Button } from "@/components/ui/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog.tsx";
import { PlusIcon } from "lucide-react";
import { useState } from "react";
import { SessionForm } from "./session-form.tsx";

interface ScheduleSessionDialogProps {
  menteeId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ScheduleSessionDialog({
  menteeId,
  open,
  onOpenChange,
}: ScheduleSessionDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold leading-7 text-black">
            Schedule a Session
          </DialogTitle>
        </DialogHeader>
        <SessionForm
          closeForm={() => onOpenChange(false)}
          menteeId={menteeId}
        />
      </DialogContent>
    </Dialog>
  );
}

interface AddSessionProps {
  menteeId: string;
}

export function AddSession({ menteeId }: AddSessionProps) {
  const [showForm, setShowForm] = useState(false);
  return (
    <>
      <Button className="w-full" onClick={() => setShowForm(true)}>
        Add Session
        <PlusIcon size={22} className="ml-4" />
      </Button>

      <ScheduleSessionDialog
        menteeId={menteeId}
        open={showForm}
        onOpenChange={setShowForm}
      />
    </>
  );
}
